import React, { useState } from "react";
import TextInput from "../../input/TextField/TextInput";
import PasswordInput from "../../input/TextField/PasswordInput";
import CheckBox from "../../input/checkBox/CheckBox";
import { BASE_URL } from "../../../customHooks/config";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Spinner from "../../layout/loader/Spinner";
import { atom, useAtom } from "jotai";
import { useAuth } from "../../../AuthProvider";

function LoginForm({ setStep }) {
  const [user, setUser] = useState({
    email: "",
    password: "",
    remember_me: false,
  });
  const navigate = useNavigate();
  const { login } = useAuth();
  const [loading, setLoading] = useState(false);
  // const [loginSuccessfull,setLoginSucessFull] = useState(false);
  // const [userDetails,setUserDetails] = useState({});
  // const validation(){
  //   let emailError ="";
  //   let passwordError = "";
  //   let isError = false;
  //   if(user.email){
  //     emailError="Please Enter Valid Email"
  //     isError = true;
  //   }
  //   if(user.password){
  //     passwordError="Please Enter Valid Pass"
  //     isError = true;
  //   }
  // }
  function isEmailComplete(email) {
    // Regular expression pattern for basic email validation
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  }
  const handleLogin = () => {
    let error = false;
    let errorValue = "";
    if (user?.email.length && isEmailComplete(user?.email) && user?.password) {
      setLoading(true);
      axios
        .post(
          `${BASE_URL}vendor/login/`,
          { ...user },
          { withCredentials: true }
        )
        .then((res) => {
          if (res?.data?.data?.error_code === 100) {
            toast.error(res?.data?.data?.message);
          } else if (res?.data?.data?.error_code === 120) {
            toast.error(res?.data?.error);
          } else if (res?.data?.data?.error_code === 140) {
            toast.error(res?.data?.error);
          } else if (res?.data?.data?.error_code === 160) {
            toast.error(res?.data?.data?.message);
          } else if (res?.data?.data?.error_code === 180) {
            toast.error(res?.data?.data?.message);
          } else if (res?.data?.data?.error_code === 200) {
            toast.error(res?.data?.data?.message);
          } else if (res?.data?.data?.error_code === "login") {
            toast.success(res?.data?.data?.message);
            const userDetails = res?.data?.data?.user_details;
            const token = res?.data?.data?.token;
            localStorage.setItem("loggedIn", JSON.stringify(userDetails));
            localStorage.setItem("token", token);
            axios.defaults.headers.common["Authorization"] = `Token ${token}`;
            login(userDetails, token);
            if(userDetails?.vendor_status === "ACCEPTED") navigate("/dashboard");
            else navigate("/all-jobs/4");
            // window.sessionStorage.setItem("loggedIn", true);
            //       axios
            //  .get(`${BASE_URL}vendor/dashboard/user_details/`, {
            //   withCredentials: true,
            // })
            // .then((res) => {
            //   console.log(res, "user_details");
            //   setUserInfo(res?.data?.data);
            //   // window.sessionStorage.setItem("user_details",JSON.stringify(res?.data?.data))
            //   navigate('/dashboard');
            // }).catch(err=>{
            //    toast.error(err?.data?.error)
            // })
          } else {
            toast.error(res?.data?.error);
          }
          setLoading(false);
        })
        .catch((err) => {
          toast.error(err?.data?.error);
          setLoading(false);
        });
    } else {
      toast.error("Please enter Email and Password");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const emailChange = (e) => {
    setUser({
      ...user,
      email: e.target.value,
    });
  };

  const passwordChange = (e) => {
    setUser({
      ...user,
      password: e.target.value,
    });
  };

  const rememberChange = (e) => {
    setUser({
      ...user,
      remember_me: e.target.checked,
    });
  };

  return (
    <div className="w-8/12 mt-10">
      <TextInput label="Email Address" onChange={emailChange} />
      <PasswordInput label="Password" onChange={passwordChange} />

      <div className="flex justify-between items-center mb-10 mt-[-10px] ">
        <CheckBox label="Remember me" onChange={rememberChange} />
        <button
          className="font-light text-sm text-[#2563EB] "
          onClick={() => {
            setStep(2);
          }}
        >
          Forgot password?
        </button>
      </div>

      <button className="btn-primary" onClick={handleLogin}>
        {loading ? <Spinner /> : "Log in"}
      </button>

      <div className=" mt-5">
        <p
          className="text-xs text-[#64748B] text-center"
          style={{ fontFamily: "gilRoy-semibold" }}
        >
          {/* Any tech related issues?{" "} */}
          Not Registered yet?
          {/* <a
            href="mailto:support@getwork.org"
            className="text-[#2563EB] cursor-pointer "
          >
            {" "}
            Connect with us{" "}
          </a> */}
          <a
            onClick={() => {
              setStep(4);
            }}
            className="text-[#2563EB] cursor-pointer "
          >
            {" "}
            Sign up
          </a>
        </p>
      </div>
    </div>
  );
}

export default LoginForm;
